import Route from '@ember/routing/route';

export default class VisitorsSettingsSignOutRoute extends Route {
  titleToken = 'Self sign-out';
}
